import { Injectable, Inject } from '@angular/core';
import * as Keycloak_ from 'keycloak-js';
const Keycloak = Keycloak_;
import { LUMILOGIN_URL, LUMILOGIN_CLIENTID, LUMILOGIN_REALM, LUMILOGIN_SECRET } from '../lumilogin.token';

// @dynamic
@Injectable({
  providedIn: 'root'
})
export class LumiloginService {

  static auth: any = {};

  private static url:string = "";
  private static realm:string = "";
  private static clientId:string = "";
  private static secret:string = "";

  constructor(@Inject(LUMILOGIN_URL) private url: string, 
              @Inject(LUMILOGIN_REALM) private realm: string,
              @Inject(LUMILOGIN_CLIENTID) private clientId: string,
              @Inject(LUMILOGIN_SECRET) private secret: string) {
    LumiloginService.url = url;
    LumiloginService.realm = realm;
    LumiloginService.clientId = clientId;
    LumiloginService.secret = secret;
  }

  static init(): Promise<any> {
    
    const keycloakAuth: Keycloak.KeycloakInstance = Keycloak({
      url: this.url,
      realm: this.realm,
      clientId: this.clientId,
      secret: this.secret,
      'ssl-required': 'external',
      'public-client': true
    });
    LumiloginService.auth.loggedIn = false;

    return new Promise((resolve, reject) => {
      keycloakAuth.init({ onLoad: 'check-sso', checkLoginIframe: false })
        .success(() => {
          LumiloginService.auth.loggedIn = false;
          LumiloginService.auth.authz = keycloakAuth;
          resolve();
        })
        .error(() => {
          reject();
        });
    });
  }

  login(): void {
    LumiloginService.auth.authz.login().success(
      () => {
        LumiloginService.auth.loggedIn = true;
      }
    );
  }

  getToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (LumiloginService.auth.authz.token) {
        LumiloginService.auth.authz
          .updateToken(5)
          .success(() => {
            resolve(<string>LumiloginService.auth.authz.token);
          })
          .error(() => {
            reject('Failed to refresh token');
          });
      } else {
        reject('Not logged in');
      }
    });
  }

  isLoggedIn(): boolean {
    return LumiloginService.auth.authz.authenticated;
  }

  getFullName(): string {
    return LumiloginService.auth.authz.tokenParsed.name;
  }

  getCompanyName() {
    return LumiloginService.auth.authz.tokenParsed.company;
  }

  getKeycloakAuth() {
    return LumiloginService.auth.authz;
  }
  
  logout(): void {
    LumiloginService.auth.authz.logout({redirectUri : document.baseURI}).success(() => {
      LumiloginService.auth.loggedIn = false;
      LumiloginService.auth.authz = null;
    });
  }
}
